import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function PasswordField({ label, value, onChange }) {
  return (
    <div className="card col gap-2" style={{ padding: 14 }}>
      <span className="mono" style={{ color: 'var(--text-3)' }}>{label}</span>
      <input
        type="password"
        placeholder="••••••••"
        value={value}
        onChange={onChange}
        required
        style={{
          flex: 1, background: 'transparent', border: 0, outline: 'none', minWidth: 0,
          color: 'var(--text)', fontSize: 14, fontFamily: 'inherit',
        }}
      />
    </div>
  );
}

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [error, setError]         = useState('');
  const [done, setDone]           = useState(false);
  const [loading, setLoading]     = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    if (password !== confirm) {
      setError('Les deux mots de passe ne correspondent pas');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Lien invalide ou expiré');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="screen" style={{ background: 'var(--ink)', minHeight: '100vh' }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: '8px 24px 40px', overflowY: 'auto' }}>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 32, marginBottom: 28 }}>
          <div className="display" style={{ fontSize: 36, lineHeight: 0.9, textAlign: 'center' }}>Nouveau mot de passe</div>
        </div>

        {error && (
          <div style={{
            padding: '10px 14px', borderRadius: 10, marginBottom: 16,
            background: 'rgba(229,80,62,0.1)', color: '#E5503E',
            fontSize: 13, fontWeight: 600, border: '1px solid rgba(229,80,62,0.25)',
          }}>{error}</div>
        )}

        {!token ? (
          <div className="card col gap-2" style={{ padding: 18, textAlign: 'center' }}>
            <span style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>
              Lien invalide. Refais une demande de réinitialisation.
            </span>
          </div>
        ) : done ? (
          <div className="card col gap-2" style={{ padding: 18, textAlign: 'center' }}>
            <span style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>
              Mot de passe modifié ! Redirection vers la connexion…
            </span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <PasswordField label="Nouveau mot de passe" value={password}
              onChange={(e) => setPassword(e.target.value)} />
            <PasswordField label="Confirme le mot de passe" value={confirm}
              onChange={(e) => setConfirm(e.target.value)} />

            <button type="submit" disabled={loading} className="btn btn-primary"
              style={{ width: '100%', marginTop: 8, padding: '15px 20px' }}>
              {loading ? 'Modification…' : 'Réinitialiser'}
            </button>
          </form>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 28, gap: 6 }}>
          <Link to="/login"
            style={{ color: 'var(--sun)', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
            Retour à la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
